import React from "react";

import TableRenderer from "./TableRenderer";
import TextRenderer from "./TextRenderer";
import KPIRenderer from "./KPIRenderer";
import ChartRenderer from "./ChartRenderer";

function ResponseRenderer({ response }) {

    //-----------------------------------------
    // Empty
    //-----------------------------------------

    if (!response) {

        return null;

    }

    console.log("🔥 RESPONSE RENDERER RECEIVED:", response);

    //-----------------------------------------
    // Plain string
    //-----------------------------------------

    if (typeof response === "string") {

        return (

            <TextRenderer

                text={response}

            />

        );

    }

    //-----------------------------------------
    // Array
    //-----------------------------------------

    if (Array.isArray(response)) {

        return (

            <>

                {

                    response.map(

                        (item, index) => (

                            <ResponseRenderer

                                key={index}

                                response={item}

                            />

                        )

                    )

                }

            </>

        );

    }

    //-----------------------------------------
    // Invalid object
    //-----------------------------------------

    if (!response.type) {

        return (

            <pre
                style={{
                    whiteSpace: "pre-wrap",
                    fontSize: 13
                }}
            >

                {

                    JSON.stringify(

                        response,

                        null,

                        2

                    )

                }

            </pre>

        );

    }

    //-----------------------------------------
    // Structured responses
    //-----------------------------------------

    switch (response.type) {

        case "text":

            return (

                <TextRenderer

                    text={response.text}

                />

            );

        
        case "scalar":

            return (

                <KPIRenderer

                    kpi={response}

                />

            );

        case "table":

            return (

                <TableRenderer

                    table={response}

                />

            );


        case "kpi":

            return (

                <KPIRenderer

                    kpi={response}

                />

            );

        case "chart":

            return (

                <ChartRenderer

                    chart={response}

                />

            );

        default:

            return (

                <pre
                    style={{
                        whiteSpace: "pre-wrap",
                        fontSize: 13
                    }}
                >

                    {

                        JSON.stringify(

                            response,

                            null,

                            2

                        )

                    }

                </pre>

            );

    }

}

export default ResponseRenderer;